export default __webpack_public_path__ + "static/media/carousel-img-12.2fcb29c7.webp";